export const COUPON_RETURN_STORAGE_KEY = "couponReturnTo";
export const COUPON_RETURN_CHECKOUT = "checkout";
export const MY_COUPONS_PATH = "/private-area#coupons";

export const markCouponReturnToCheckout = () => {
  try {
    sessionStorage.setItem(COUPON_RETURN_STORAGE_KEY, COUPON_RETURN_CHECKOUT);
  } catch {
    /* ignore */
  }
};

export const clearCouponReturn = () => {
  try {
    sessionStorage.removeItem(COUPON_RETURN_STORAGE_KEY);
  } catch {
    /* ignore */
  }
};

export const isCouponCheckoutReturn = (location) => {
  const fromState = location?.state?.couponReturnTo;
  if (fromState === COUPON_RETURN_CHECKOUT) return true;

  try {
    return (
      sessionStorage.getItem(COUPON_RETURN_STORAGE_KEY) ===
      COUPON_RETURN_CHECKOUT
    );
  } catch {
    return false;
  }
};
